import ShowcaseItem from "@/components/ShowcaseItem"
export default {
  name: 'Showcase',
  components: {
    ShowcaseItem
  },
  props: [
    'showcase',
    'items',
    'isDownload'
  ],
  data() {
    return {
    }
  },
  methods: {
    onDownload() {
      window.open('../../assets/Resume.pdf')
    }
  },
}